export enum CompanyRoles {
  COMPANYADMIN = 'COMPANYADMIN',
  COMPANYACCOUNTANT = 'COMPANYACCOUNTANT',
  COMPANYDRIVERMANAGER = 'COMPANYDRIVERMANAGER',
}

export const permissionsMap: { [key: string]: string[] } = {
  Drivers: [CompanyRoles.COMPANYDRIVERMANAGER],
  Dashboard: [CompanyRoles.COMPANYADMIN],
  Account: [],
  Rentals: [CompanyRoles.COMPANYACCOUNTANT],
  Payments: [CompanyRoles.COMPANYACCOUNTANT, CompanyRoles.COMPANYADMIN],
  groups: [CompanyRoles.COMPANYDRIVERMANAGER],
  'group-details': [CompanyRoles.COMPANYDRIVERMANAGER],
};

export const isAccessible = (routeName: string, roles?: string[]): boolean => {
  const route = permissionsMap[routeName];
  if (!roles || !route) {
    return true;
  }

  for (let i = 0; i < route.length; i += 1) {
    if (roles!.indexOf(route[i]) === -1) {
      return false;
    }
  }

  return true;
};
